<template>
  <Modal v-model="sampleOrderModal" :title="$t('key1006241')" class-name="sampleOrderStyle" width="600" :transfer="false"
    :mask-closable="false" @on-visible-change="sampleOrderChange">
    <Form ref="sampleOrderForm" :model="sampleOrderForm" :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem" style="width: 90%;">
        <h2 class="font-weight-bold mb10 pl20">{{ $t('key1006425') }}</h2>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006418')" prop="ymsLogisServiceId">
            <Select v-model="sampleOrderForm.ymsLogisServiceId" transfer filterable :placeholder="$t('key1001359')" @on-change="selectChange">
              <Option v-for="(item, index) in internalLogisticsData" :key="index" :value="item.ymsLogisServiceId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <div class="flex align-items-center mb10">
          <h2 class="font-weight-bold pl20">{{ $t('key1006426') }}</h2>
          <Tooltip max-width="300" placement="top" class="ml5 cursor" transfer :content="$t('key1006419')">
            <Icon size="17" type="md-help-circle"/>
          </Tooltip>
        </div>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006420')" prop="deliveryName">
            <Input v-model.trim="sampleOrderForm.deliveryName" :placeholder="$t('key1006421')"/>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006422')" prop="deliveryGroup">
            <Input v-model.trim="sampleOrderForm.deliveryGroup" :placeholder="$t('key1006423')"/>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <div class="flex justify-content-between align-items-center">
        <div class="flex align-items-center">
          <h2 class="distributorThemeColor">{{ $t('key1000121') + estimateFreightPrice + ' ' + currencyState }}</h2>
          <Tooltip max-width="300" placement="top" class="ml5 cursor" transfer :content="$t('key1006424')">
            <Icon size="17" type="md-help-circle"/>
          </Tooltip>
        </div>
        <div class="flex align-items-center">
          <Button @click="sampleOrderModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="sampleOrderBtn">{{ $t('key1000111') }}</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getYunLogisticsAll} from "@/utils/common";

export default {
  name: "sampleOrderModal",
  mixins: [Mixin],
  data() {
    return {
      sampleOrderModal: false,
      sampleOrderForm: {
        ymsLogisServiceId: null, // 物流
        deliveryName: '', // 收货人
        deliveryGroup: '', // 收货组
      },
      ruleValidate: {
        ymsLogisServiceId: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006417'), trigger: 'change'}
        ],
      },
      internalLogisticsData: [],
      estimateFreightPrice: '-',
      goodsData: [],
      ymsPlatformOrderIdList: [],
    };
  },
  methods: {
    // 初始化数据
    initSampleOrder(selectTableData) {
      let v = this;
      (async () => {
        await v.getOrderItemInfo(selectTableData);
        await v.getInternalLogisticsData();
      })();
    },
    // 获取当前订单下的货品信息
    getOrderItemInfo(selectTableData) {
      let v = this;
      v.ymsPlatformOrderIdList = [];
      let ymsPlatformOrderIds = [];
      selectTableData.map((item) => {
        ymsPlatformOrderIds.push(item.ymsPlatformOrderId);
        v.ymsPlatformOrderIdList.push({
          ymsPlatformOrderId: item.ymsPlatformOrderId
        });
      });
      if (ymsPlatformOrderIds.length > 0) {
        v.axios.post(api.post_ymsPlatformOrder_queryDetailByIds, ymsPlatformOrderIds, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let newList = [];
              data.map((item) => {
                let ymsPlatformOrderPackageRelateds = item.ymsPlatformOrderPackageRelateds || [];
                if (ymsPlatformOrderPackageRelateds.length > 0) {
                  ymsPlatformOrderPackageRelateds.map((ele) => {
                    if (ele.ymsPackageInfo) {
                      let ymsPackageGoods = ele.ymsPackageInfo.ymsPackageGoods || [];
                      if (ymsPackageGoods.length > 0) {
                        ymsPackageGoods.map((talg) => {
                          newList.push({
                            quantity: talg.quantity,
                            ymsProductGoodsId: talg.ymsProductGoodsId
                          });
                        });
                      }
                    }
                  });
                }
              });
              if (newList.length > 0) {
                // 累加并去重
                let list = Object.values(newList.reduce((acc, cur) => {
                  if (acc[cur.ymsProductGoodsId]) {
                    acc[cur.ymsProductGoodsId].quantity += cur.quantity;
                  } else {
                    acc[cur.ymsProductGoodsId] = {ymsProductGoodsId: cur.ymsProductGoodsId, quantity: cur.quantity};
                  }
                  return acc;
                }, {}));
                v.goodsData = list;
              }
            }
          }
        });
      }
    },
    // 计算当前订单号中所有sku的运费
    calculateShippingCosts(list) {
      let v = this;
      v.estimateFreightPrice = '-';
      let query = {
        countryCode: 'CN', // 默认是国内物流
        priceTrialGoodsBoList: list,
        shippingMethodId: null,
        ymsDistributorMerchantId: v.$store.state.erpConfig.merchant.merchantId,
        ymsLogisServiceId: v.sampleOrderForm.ymsLogisServiceId
      };
      v.axios.post(api.post_ymsProductInfo_api_priceTrial + '?fresh=KEEPNEW', query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.estimateFreightPrice = data.estimateFreightPrice;
          }
        }
      });
    },
    // 获取物流数据
    getInternalLogisticsData() {
      let v = this;
      v.internalLogisticsData = [];
      getYunLogisticsAll().then((data) => {
        v.internalLogisticsData = data.filter((item) => {
          return item.channelType === 0;
        });
      });
      v.sampleOrderModal = true;
    },
    // 执行发货
    sampleOrderBtn() {
      let v = this;
      let query = {
        deliveryGroup: v.sampleOrderForm.deliveryGroup,
        deliveryName: v.sampleOrderForm.deliveryName,
        platformOrderImplementShipmentsBos: v.ymsPlatformOrderIdList,
        trackingNumber: null,
        ymsLogisServiceId: v.sampleOrderForm.ymsLogisServiceId
      };
      v.$refs['sampleOrderForm'].validate((valid) => {
        if (valid) {
          v.axios.put(api.put_ymsPlatformOrder_implementShipment, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000672')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006242'));
              v.sampleOrderModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 选择物流之后，自动计算运费
    selectChange(value) {
      this.calculateShippingCosts(this.goodsData);
    },
    // 监听弹窗
    sampleOrderChange(value) {
      if (!value) {
        this.goodsData = [];
        this.estimateFreightPrice = '-';
        this.ymsPlatformOrderIdList = [];
        this.$refs['sampleOrderForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>